import { KeyboardEvent } from 'react';

import NextImage from '@com/_core/NextImage';
import { HomeSpecialitiesResultDataModel } from '@models/home';
import Icon from '@utilities/icon';
import { colors } from '@configs/Theme';

type VerticalSpecialityCardProps = {
  className?: string;
  specialityData: Omit<HomeSpecialitiesResultDataModel, 'titleEn' | 'parentId'>;
  onClick?: () => void;
  hasLabel?: boolean;
};

const VerticalSpecialityCard = ({
  specialityData,
  onClick,
  hasLabel = false,
}: VerticalSpecialityCardProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      onClick?.();
    }
  };

  return (
    <div
      className={`flex flex-col h-[92px] w-[70px] justify-center ${
        hasLabel ? 'relative' : ''
      }`}
      onClick={() => onClick?.()}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      role="button"
    >
      {hasLabel && (
        <div className="flex items-center justify-center gap-x-0.5 min-w-[54px] absolute top-[-8px] right-6 bg-surface-accent rounded-full z-20 px-1 min-h-[18px]">
          <Icon
            name="Clock"
            width={0.8}
            height={0.8}
            viewBox="0 0 24 24"
            fill={colors.white}
          />
          <p className="text-[8px] mt-0.5 text-Label/2xSmall text-content-onInverse text-nowrap">
            ۲۴ ساعته
          </p>
        </div>
      )}

      <div className="w-full h-[68px] flex items-center justify-center overflow-hidden bg-surface-secondary rounded-md">
        <NextImage
          src={specialityData?.imageUrl}
          alt={specialityData?.title ?? 'speciality'}
          quality={100}
          width={70}
          height={68}
          imageClassName="max-h-[68px]"
          className="w-full h-full object-contain"
        />
      </div>

      <span className="text-content-primary text-Label/xSmall truncate text-center">
        {specialityData?.title}
      </span>
    </div>
  );
};

export default VerticalSpecialityCard;
